import Pia from '../pia/type';

export const fundPercentKeys: (keyof Pia.FundsRows)[] = [
  'reported_property_management_fees',
  'reported_purchase_and_sale_fees',

  'reported_max_construction_and_works_fees',
  'reported_max_custodian_bank_fees',
  'reported_max_management_fees',
  'reported_max_property_management_fees',
  'reported_max_purchase_and_sale_fees',
  'reported_max_share_buyback_commissions',
  'reported_max_share_issue_commissions',
  'reported_share_buyback_commissions',
  'reported_share_issue_commissions',
  'reported_management_fees',

  'reported_custodian_bank_fees',
  'reported_construction_and_works_fees',
  'computed_ebit_margin',
  'computed_median_cost_of_debt',

  'reported_ter_gav',
  'reported_ter_mv',
  'reported_ter_nav',

  'computed_current_ratio',
  'computed_debt_ratio',

  'computed_loan_to_value',
  'computed_net_initial_yield',

  'computed_payout_ratio',

  'computed_price_to_book_value',
  'computed_roa',
  'computed_roce',
  'computed_roe',
  'reported_debt_ratio',

  'reported_dividend_yield',

  'reported_ebit_margin',

  'reported_payout_ratio',
  'reported_performance',
  'reported_rental_losses',

  'reported_roa',
  'reported_roce',
  'reported_roe',
  'reported_roi',
  'reported_roic',

  'computed_weighted_average_cost_of_debt',

  'computed_agio_at_year_end',

  'reported_agio_at_year_end',

  'computed_current_agio_after_distribution',
  'computed_current_agio_compounded',

  'market_dividend_yield',

  'market_five_years_avg_dividend_yield',
  'market_five_years_return',
  'market_three_years_return',
  'computed_three_years_total_return',
  'computed_five_years_total_return',

  'market_mtd_net_return',
  'market_one_month_return',
  'market_one_year_return',
  'market_qtd_net_return',

  'market_six_months_return',
  'market_three_months_return',

  'market_ytd_net_return',
  'market_one_year_total_return',
  'market_three_years_total_return',
  'market_five_years_total_return',
  'market_share_price_var',
  'market_alpha',
  'reported_share_fossil',
  'reported_coverage_share_fossil',
  'computed_energy_source_heating_type_coverage',
];

export default fundPercentKeys;
